export const FILE_DEFAULT_MAX_SIZE = 20_000_000; // 20Mo

// @NOTE this constant is linked to the infra lifecycle rule on the S3 bucket
// see infra/saas/console-api/data-storage.tf l43
export const UPLOAD_REF_TTL_SEC = 24 * 60 * 60; // 1 day (in seconds)
